export enum ProviderTranslationStatus {
  Unknown = 0,
  Active = 1,
  Inactive = 2
}
